<template>
  <div class="page">
    <CookieBanner />
    <div class="page__header">
      <div class="container">
        <div class="page__header-box">
          <a
            href="https://konkurs.kruzhok.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="@/assets/images/competition-logo.svg"
              alt="Логотип конкурса кружков"
              class="header__logo-ai"
            />
          </a>
          <BaseButton
            v-if="!user"
            tag="a"
            :href="loginURL"
            theme="secondary"
            size="sm"
            @click="handleLoginClick"
            >Регистрация / Вход</BaseButton
          >
          <ProfileBlock v-else :user="user" class="page__header-profile" />
        </div>
      </div>
    </div>

    <div class="page__body">
      <slot />
    </div>

    <AppFooter />
  </div>
</template>
<script>
import { request } from "@/plugins/request";
import AppFooter from "@/components/AppFooter.vue";
import ProfileBlock from "@/components/ProfileBlock.vue";

import { CONTEST_EVENTS } from "@/constants";
import CookieBanner from "./CookieBanner.vue";
export default {
  name: "PageLayout",
  components: {
    AppFooter,
    ProfileBlock,
    CookieBanner,
  },
  computed: {
    loginURL() {
      let next = window.location.origin + process.env.VUE_APP_ROOT_PREFIX;
      const from = this.$route.query.from || "/";
      return (
        process.env.VUE_APP_TALENT_HOST + `/signin?redirect_uri=${next}${from}`
      );
    },
    user() {
      return this.$store.state.user.user;
    },
    requests() {
      return this.$store.state.requestPreparing.requests;
    },
  },
  async created() {
    if (!this.user) return;
    let orgs = [];
    if (!this.$store.state.requestPreparing.organizations.length) {
      orgs = await this.$store.dispatch("requestPreparing/getOrganizations", {
        userId: this.user.id,
      });
    }
    if (orgs.length) {
      await this.getUserRequests();
    }
    this.$store.dispatch("requestPreparing/getEventsFields");
  },
  methods: {
    async getUserRequests() {
      try {
        await Promise.all(
          Object.values(CONTEST_EVENTS).map((id) => {
            return this.$store.dispatch("requestPreparing/getRequest", {
              id,
              userId: this.user.id,
            });
          })
        );
        if (this.requests.length > 1) {
          this.showRequestWarningModal({
            requests: this.requests,
            confirmHandler: (request) => {
              this.requests = [request];
            },
          });
        }
      } catch (error) {
        this.$store.commit("requestPreparing/SET_REQUESTS", []);
        this.showErrorModal({
          content: "Не удалось получить заявки",
          message: JSON.stringify(error?.response?.data),
        });
      }
    },
    async handleLoginClick(e) {
      if (process.env.NODE_ENV !== "development") {
        return;
      }
      e.preventDefault();
      const [email, password] = prompt(
        "Укажите email и пароль через разделитель ;",
        "email@email.mail;password"
      ).split(";");
      const fd = new FormData();
      fd.append("username", email);
      fd.append("password", password);
      fd.append("grant_type", "password");
      try {
        const { data } = await request({
          method: "POST",
          url: "/oauth/issue-token/",
          data: fd,
        });
        if (data?.access_token) {
          this.$store.commit("user/SET_TOKEN", data.access_token);
          await this.$store.dispatch("user/getMe");
        }
        let orgs = [];
        orgs = await this.$store.dispatch("requestPreparing/getOrganizations", {
          userId: this.user.id,
        });
        if (orgs.length) {
          await this.getUserRequests();
        }
      } catch (error) {
        this.showErrorModal({
          content: "Не удалось авторизоваться",
          message: JSON.stringify(error?.response?.data),
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page {
  display: flex;
  min-height: 100vh;
  flex-direction: column;

  &__header-profile {
    position: relative;
  }

  &__header-box {
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__body {
    flex: 1 1 auto;
  }
}
</style>
